export default __webpack_public_path__ + "static/media/Kunde.238f096c.png";